import React from 'react';
import { Icon, Row, Col, Button } from 'antd';
import { observer } from 'mobx-react';
import { WeaLocaleProvider, WeaInput } from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;

@observer
export default class ColumnAdd extends React.Component<{ sureFun: (string) => void, defaultTabSet?: String }, any>{

    constructor(props) {
        super(props);
        this.state = { isAdd: false, name: '' };
    }

    headerClick = () => {
        if (!this.state.isAdd) {
            this.setState({ isAdd: true });
        }
    }

    addChange = v => { this.setState({ name: v }) }

    sureClick = () => {
        const { sureFun } = this.props;
        sureFun && sureFun(this.state.name);
        this.setState({ name: '', isAdd: false });
    }

    cancel = () => { this.setState({ isAdd: false }) }

    render() {
        const { defaultTabSet } = this.props;
        let headerStyle: any = { 'cursor': 'pointer' };
        if (this.state.isAdd) {
            headerStyle['height'] = '95px';
        }
        if (defaultTabSet == "2") {
            headerStyle['display'] = 'none';
        }
        return <div className="board-column muuri-item muuri-item-shown">
            <div className="board-column-header" style={headerStyle} onClick={this.headerClick}>
                {
                    !this.state.isAdd ? <div style={{ textAlign: 'center', height: '100%', paddingTop: '20px', fontSize: '15px' }}>
                        <Icon ecId={`${this && this.props && this.props.ecId || ''}_Icon@0gguxh`} style={{ color: '#67DAC4' }} type="plus" />&nbsp;&nbsp;&nbsp;&nbsp;{getLabel(30131, "新建分组")}
                    </div> :
                        <div style={{ padding: '5px' }}>
                            <Row ecId={`${this && this.props && this.props.ecId || ''}_Row@2ekrnd`} style={{ marginTop: '10px' }}>
                                <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@j74758`} span={24}>
                                    <WeaInput ecId={`${this && this.props && this.props.ecId || ''}_WeaInput@kpa9m2`} isBase64={true}
                                        inputType='multilang' style={{ borderColor: '#67DAC4', borderRadius: '5px' }}
                                        value={this.state.name}
                                        onChange={this.addChange}
                                    />
                                </Col>
                            </Row>
                            <Row ecId={`${this && this.props && this.props.ecId || ''}_Row@b76eeh`} style={{ marginTop: '10px' }}>
                                <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@7g49ap`} span={4}></Col>
                                <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@k1kscb`} span={8}>
                                    <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@mq0o55`} onClick={this.sureClick} style={{ backgroundColor: '#67DAC4', borderColor: '#67DAC4' }} type="primary">{getLabel(382958, "确定")}</Button>
                                </Col>
                                <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@mbjdaj`} span={8}>
                                    <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@d2agij`} onClick={this.cancel}>{getLabel(201, "取消")}</Button>
                                </Col>
                                <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@1uafgj`} span={4}></Col>
                            </Row>
                        </div>
                    }
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/board/ColumnAdd.tsx